import $ from 'jquery'

/**
 * @package     Image Hopper
 * @copyright   Copyright (c) 2021, Image Hopper
 * @license     http://opensource.org/licenses/gpl-2.0.php GNU Public License
 */

export function setImageSize (pond) {
  if (pond.offsetWidth > 900) {
    $(pond).attr('data-size', 'small')
  } else if (pond.offsetWidth > 650) {
    $(pond).attr('data-size', 'medium')
  } else {
    $(pond).attr('data-size', 'large')
  }
}
